import { render, staticRenderFns } from "./music-btn.vue?vue&type=template&id=a4e61d46&scoped=true&"
import script from "./music-btn.vue?vue&type=script&lang=js&"
export * from "./music-btn.vue?vue&type=script&lang=js&"
import style0 from "./music-btn.vue?vue&type=style&index=0&id=a4e61d46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e61d46",
  null
  
)

export default component.exports